<template>
  <div class="dashboard reviews">
    <div class="navbar">
      <div class="left">
        <div class="title">
          <div class="wrap">
            <h4>История действий</h4>
            <div class="sub-title"></div>
          </div>
        </div>

      </div>
    </div>


    <div class="table-flex-responsive">

      <div class="row header sticky">
        <div class="col-1"></div>
        <div class="col">Пользователь</div>
        <div class="col-5">Действие</div>
        <div class="col-3">Дата</div>

      </div>
      <template v-for="(object, index) in objects">
        <div class="row line">

          <div class="col-1 number">
            <div class="sub-head">№</div>
            {{ (index + 1) }}
          </div>
          <div class="col sub-head">Пользователь</div>
          <div class="col">
            {{ object.user_name }}
          </div>
          <div class="col sub-head">Действие</div>
          <div class="col-lg-5">
            {{ object.message }}
          </div>
          <div class="col sub-head">Дата</div>
          <div class="col">
            {{ $moment(object.created_at).format("DD.MM.YY HH:mm") }}
          </div>
          <div class="col sub-head"></div>

        </div>
      </template>

    </div>

<PagerList v-bind:pager="pager" v-bind:updatePage="updatePage" v-bind:page="page"></PagerList>
  </div>
</template>

<script>

import dataMixin from "@/views/dictionary/mixins";
import {HistoryApi} from "@/api/history";

export default {
  name: 'HistoryChange',
  data() {
    return {
    }
  },
  mixins: [dataMixin],
  computed: {
    projectId: {
      get: function () {
        return this.$store.getters.currentProjectId;
      },
      set: function () {
      }
    },
  },
  mounted() {
    this.getData()

  },
  methods: {
     updatePage(page) {
      this.page = page
    },
    getData() {
      HistoryApi.list(this.page).then(response => {
        this.objects = response.results;
        this.all_count = response.count
      })
    },
  }
}
</script>

<style scoped lang="scss">

</style>

